import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import moment from 'moment';

import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class PublicationProvideUrl extends Component {
  handlePublished(e, value) {
    const published = e.target.checked ? value : !value;
    this.props.assignAttribute('published', published);
  }

  handleText(e, key) {
    const { fields } = this.props;

    e.preventDefault();

    let publishInfo = fields.publishInfo || {};
    publishInfo[key] = e.target.value || '';

    this.props.assignAttribute('publishInfo', { ...publishInfo });
  }

  handleDate(date) {
    const { fields } = this.props;
    let publishInfo = fields.publishInfo || {};

    const firstDate = moment(date).format('MM/DD/YYYY');
    publishInfo['firstDate'] = firstDate;

    this.props.assignAttribute('publishInfo', { ...publishInfo });
  };

  isValidHttpUrl(str) {
    let url;

    try {
      url = new URL(str);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }

  handleNext() {
    const { fields } = this.props;
    const publishInfo = fields.publishInfo || {};

    this.props.hideAlert();
    let checked = true;

    if (!publishInfo.url) {
      checked = false;
      this.props.alert('error', 'Please check the required fields.');
    }

    if (!this.isValidHttpUrl(publishInfo.url)) {
      checked = false;
      this.props.alert('error', 'URL is invalid.');
    }

    if (checked) {
      this.props.assignAttribute('publishInfoStatus', fields.published);
      this.props.assignAttribute('workTitles', [{
        URLs: publishInfo.url,
      }]);
      this.props.router.push('/publication-reg/authors');
    }
  }

  handleBack() {
    this.props.router.goBack();
  }

  render() {
    const { fields } = this.props;
    const publishInfo = fields.publishInfo || {};

    return (
      <div className="publish">
        <Heading text="Provide Your Website’s URL" />
        <div className="content">
          <Form>
            <div className="inner">
              <FormGroup>
                <ControlLabel>
                  <span className="text-red">*</span><b>URL</b>:
                </ControlLabel>
                <FormControl
                  type="text"
                  placeholder="Type here"
                  value={publishInfo.url || ''}
                  onChange={(e) => this.handleText(e, 'url')}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handleBack()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationProvideUrl);



// WEBPACK FOOTER //
// src/components/Publication/PublicationProvideUrl.jsx